import { DropDownBoxComponentSpacing, StateDropDown } from '@apply/components';
import { useBorrowerEntityState } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';
import UsaStates, { IStateResult } from 'usa-states';

interface BorrowerStateProps {
    readOnly?: boolean;
    isReview?: boolean;
}

export const BorrowerState: React.FC<BorrowerStateProps> = ({ readOnly = false, isReview = false }) => {
    const label = 'State';
    const [state, set_state] = useBorrowerEntityState();
    const usaStates: IStateResult[] = new UsaStates.UsaStates().states;

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={usaStates.find((s) => s.abbreviation == state)?.name}
                />
            ) : (
                <StateDropDown
                    id={'borrowerAddressState'}
                    value={state}
                    onChange={(value) => set_state(value)}
                    label={label}
                    required={true}
                    readOnly={readOnly}
                    componentSpacing={DropDownBoxComponentSpacing.SmallSpacing}
                />
            )}
        </>
    );
};
